import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { Table as VirtualizedTable, Column, AutoSizer } from 'react-virtualized';
import { ColumnsType, BetType } from './config';

const HEADER_HEIGHT = 32;
const ROW_HEIGHT = 40;

interface VirtualizedTablePropsType {
    columns: ColumnsType;
    data: Array<BetType>;
}

const rowStyles = (index: number): React.CSSProperties => {
    if (index === -1) {
        return {
            backgroundColor: 'hsl(var(--tailwind-background))',
            borderBottom: '1px solid hsl(var(--tailwind-border))',
            boxSizing: 'border-box',
            fontSize: '0.75rem',
            lineHeight: '1rem',
        };
    } else if (index % 2 === 0) {
        return {
            backgroundColor: 'hsl(var(--tailwind-muted))',
            border: 'none',
            borderBottom: '1px solid hsl(var(--tailwind-border))',
            boxShadow: 'none',
            fontSize: '0.75rem',
            lineHeight: '1rem',
        };
    } else {
        return {
            backgroundColor: 'hsl(var(--tailwind-background))',
            border: 'none',
            borderBottom: '1px solid hsl(var(--tailwind-border))',
            boxShadow: 'none',
            fontSize: '0.75rem',
            lineHeight: '1rem',
        };
    }
};

export const VirtualizedTableV2 = observer('VirtualizedTableV2', ({ columns, data }: VirtualizedTablePropsType) => {
    let tableWidth = 0;
    const cols = columns.map((col) => {
        tableWidth += col.width;
        return (
            <Column
                key={col.id}
                label={col.header}
                cellDataGetter={({ rowData }: { rowData: BetType }) => {
                    const cellValue = col.value(rowData);
                    return cellValue;
                }}
                cellRenderer={({ cellData }) => cellData}
                dataKey={col.id}
                width={col.width}
                headerRenderer={({ label }) => (
                    <div className='text-xs text-muted-foreground border-b border-border'>{label}</div>
                )}
            />
        );
    });

    return (
        <AutoSizer>
            {({ height }: { height: number }) => (
                <VirtualizedTable
                    height={height}
                    width={tableWidth}
                    headerHeight={HEADER_HEIGHT}
                    rowHeight={ROW_HEIGHT}
                    rowCount={data.length}
                    rowGetter={({ index }: { index: number }) => {
                        return data[index];
                    }}
                    rowStyle={({ index }: { index: number }) => {
                        return rowStyles(index);
                    }}
                    style={{ paddingRight: '8px' }}
                >
                    {cols}
                </VirtualizedTable>
            )}
        </AutoSizer>
    );
});
